import { Grid } from '@statsbomb/kitbag-components';
import React from 'react';
import DownloadsInProgress from '../../components/DownloadsInProgress';
import EditsDisplay from '../../components/EditsDisplay';

export function Edits() {
  return (
    <Grid>
      <Grid item xs={12}>
        <EditsDisplay displayCount={25} />
      </Grid>
      <Grid item xs={12}>
        <DownloadsInProgress displayCount={25} />
      </Grid>
    </Grid>
  );
}

export default { Edits };
